import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PhotoDTOModel } from 'src/app/models/photoDTO.model';

@Component({
  selector: 'app-edit-photo',
  templateUrl: './edit-photo.component.html',
  styleUrls: ['./edit-photo.component.scss'],
})
export class EditPhotoComponent implements OnInit {
  @Input() photoDTO: PhotoDTOModel;
  comment: string;

  constructor(public modalController: ModalController) { }

  ngOnInit() {
    this.comment = this.photoDTO.comment;
  }

}
